import httpClient from '../httpService';
import {
    BSKT_Lop,
    BSKT_Lop_TreeView_Item,
    BSKT_Lop_ViewModel,
    CreateLopHocBSKTRequest,
    PhanLopTuDongRequest,
    TaoLopTuDongRequest,
    ThongKeHocVienBSKTChiTietResponse,
    ThongKeHocVienBSKTResponse,
    ThongKeVaMoLopTuDongResponse,
    TreeNode
} from './LopModels';

const LopApiUrl = '/api/Lop/';

function unwrapArrayResponse<T>(res: any): T[] {
    if (Array.isArray(res)) return res;
    if (Array.isArray(res?.data)) return res.data;
    if (Array.isArray(res?.data?.data)) return res.data.data;
    if (Array.isArray(res?.data?.items)) return res.data.items;
    if (Array.isArray(res?.items)) return res.items;
    return [];
}

function unwrapItemResponse<T>(res: any, fallback: T): T {
    if (res && typeof res === 'object' && !Array.isArray(res) && !('data' in res)) return res as T;
    if (res?.data && typeof res.data === 'object' && !Array.isArray(res.data) && !('data' in res.data)) return res.data as T;
    if (res?.data?.data && typeof res.data.data === 'object') return res.data.data as T;
    return fallback;
}

function unwrapBooleanResponse(res: any): boolean {
    if (typeof res === 'boolean') return res;
    if (typeof res?.data === 'boolean') return res.data;
    if (typeof res?.data?.data === 'boolean') return res.data.data;
    return false;
}

export const lopService = {
    thongKeVaMoLopTuDong: async (dotTuyenId: number, dotHocId: number): Promise<ThongKeVaMoLopTuDongResponse> => {
        const res = await httpClient.get(`${LopApiUrl}ThongKeVaMoLopTuDong/${dotTuyenId}/${dotHocId}`);
        return unwrapItemResponse<ThongKeVaMoLopTuDongResponse>(res, {} as ThongKeVaMoLopTuDongResponse);
    },
    thongKeHocVienBSKT: async (dotHocId: number, strict = false): Promise<ThongKeHocVienBSKTResponse[]> => {
        const res = await httpClient.get(`${LopApiUrl}ThongKeHocVienBSKT/${dotHocId}`);
        if (strict && ((res as any)?.is_success === false || res?.data?.is_success === false)) throw Error('Statistics request failed');
        return unwrapArrayResponse<ThongKeHocVienBSKTResponse>(res);
    },
    thongKeHocVienBSKTChiTiet: async (dotHocId: number, strict = false): Promise<ThongKeHocVienBSKTChiTietResponse[]> => {
        const res = await httpClient.get(`${LopApiUrl}ThongKeHocVienBSKTChiTiet/${dotHocId}`);
        if (strict && ((res as any)?.is_success === false || res?.data?.is_success === false)) throw Error('Statistics request failed');
        return unwrapArrayResponse<ThongKeHocVienBSKTChiTietResponse>(res);
    },

    taoLopTuDong: async (body: TaoLopTuDongRequest): Promise<boolean> => {
        const res = await httpClient.post(`${LopApiUrl}TaoLopTuDong`, body);
        return unwrapBooleanResponse(res);
    },

    phanLopTuDong: async (body: PhanLopTuDongRequest): Promise<boolean> => {
        const res = await httpClient.post(`${LopApiUrl}PhanLopTuDong`, body);
        return unwrapBooleanResponse(res);
    },

    selectByDotHoc: async (dotHocId: number): Promise<BSKT_Lop_ViewModel[]> => {
        const res = await httpClient.get(`${LopApiUrl}SelectByDotHoc/${dotHocId}`);
        return unwrapArrayResponse<BSKT_Lop_ViewModel>(res);
    },
    insertLop: async (body: CreateLopHocBSKTRequest) => {
        const res = await httpClient.post(`${LopApiUrl}CreateLop`, body);
        return unwrapItemResponse(res, null);
    },
    updateLop: async (body: CreateLopHocBSKTRequest) => {
        const res = await httpClient.post(`${LopApiUrl}UpdateLop`, body);
        console.log('update lop: ' + JSON.stringify(unwrapItemResponse(res, null)));
        return unwrapItemResponse(res, null);
    },
    deleteLop: async (id: number): Promise<BSKT_Lop_ViewModel> => {
        const res = await httpClient.delete(`${LopApiUrl}Delete/${id}`);
        return unwrapItemResponse<BSKT_Lop_ViewModel>(res, {} as BSKT_Lop_ViewModel);
    },
    getTreeViewLop: async (): Promise<BSKT_Lop_TreeView_Item[]> => {
        const res = await httpClient.get(`${LopApiUrl}GetTreeViewLop`);
        console.log(JSON.stringify(res));
        return unwrapArrayResponse<BSKT_Lop_TreeView_Item>(res);
    },
    getAll: async (): Promise<BSKT_Lop[]> => {
        const res = await httpClient.get(`${LopApiUrl}GetAll`);
        return unwrapArrayResponse<BSKT_Lop>(res);
    },
    getByID: async (id: number): Promise<BSKT_Lop_ViewModel> => {
        const res = await httpClient.get(`${LopApiUrl}GetById/${id}`);
        return unwrapItemResponse<BSKT_Lop_ViewModel>(res, {} as BSKT_Lop_ViewModel);
    }
};
